import { apiDelete, apiGet, apiGetPaginated, apiPatch, apiPost, PaginatedResult } from '../client'

export type MessageStatus = 'SENT' | 'READ'

export interface ChatParticipant {
  isAdmin: boolean
  joinedAt: string
  user?: { avatarUrl?: string | null; firstName?: string; id: string; lastName?: string } | null
  userId: string
}

export interface ChatMessage {
  attachmentType?: string | null
  attachmentUrl?: string | null
  content: string
  conversationId: string
  createdAt: string
  editedAt?: string | null
  id: string
  isDeleted?: boolean
  replyToId?: string | null
  sender?: { avatarUrl?: string | null; firstName?: string; id: string; lastName?: string } | null
  status: MessageStatus
}

export interface ChatConversation {
  createdAt: string
  id: string
  isGroup: boolean
  lastMessage?: ChatMessage | null
  participants: ChatParticipant[]
  title?: string | null
  unreadCount?: number
  updatedAt: string
}

export interface StartConversationPayload {
  participantIds: string[]
  title?: string
}

export interface EligibleContact {
  avatarUrl?: string | null
  name: string
  role: string
  subtitle?: string | null
  userId: string
}

export interface SendMessagePayload {
  attachmentType?: string
  attachmentUrl?: string
  content: string
  replyToId?: string
}

export const startConversation = (payload: StartConversationPayload) => apiPost<ChatConversation>('/chat/conversations', payload)

export const getEligibleContacts = () => apiGet<EligibleContact[]>('/chat/eligible-contacts')

export const listConversations = () => apiGet<ChatConversation[]>('/chat/conversations')

export const listMessages = (conversationId: string, params?: { limit?: number; page?: number }): Promise<PaginatedResult<ChatMessage[]>> =>
  apiGetPaginated<ChatMessage[]>(`/chat/conversations/${conversationId}/messages`, { params })

export const sendMessageRest = (conversationId: string, payload: SendMessagePayload) =>
  apiPost<ChatMessage>(`/chat/conversations/${conversationId}/messages`, payload)

export const editMessageRest = (messageId: string, content: string) =>
  apiPatch<ChatMessage>(`/chat/messages/${messageId}`, { content })

export const deleteMessage = (messageId: string) => apiDelete<void>(`/chat/messages/${messageId}`)
